import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GECKO_CONSTS, GeckoField } from 'ui';
import GeckoRequest from 'services/gecko-request';

import './index.scss';

class AsyncSelect extends Component {
  static propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func,
    field: PropTypes.object,
    selectUrl: PropTypes.string,
    getUrl: PropTypes.string,
    selectFunc: PropTypes.func,
    optionTransform: PropTypes.func.isRequired,
    onOptionsUpdated: PropTypes.func,
    placeholder: PropTypes.string,
    multi: PropTypes.bool,
  };

  static defaultProps = {
    field: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      options: [],
      searching: false,
      loadingOptions: false,
      searchString: null,
      page: 1,
    };
  }

  componentDidMount() {
    return this.refreshOptions('');
  }

  componentDidUpdate() {
    if (this.props.getUrl && this.props.value) {
      const values = this.props.multi ? this.props.value : [this.props.value];
      values.forEach((value) => {
        const option = this.state.options.find(
          (option) => String(option.value) === String(value)
        );
        if (!option) {
          GeckoRequest.get(`${this.props.getUrl}/${value}`).then((option) => {
            this.appendOptions([this.props.optionTransform(option)]);
          });
        }
      });
    }
  }

  setOptions(options) {
    let seenOpts = {};
    this.setState(
      {
        options: options.filter((opt) => {
          if (seenOpts[opt.value]) {
            return false;
          }
          seenOpts[opt.value] = true;
          return true;
        }),
        loadingOptions: false,
      },
      () => {
        if (this.props.onOptionsUpdated) {
          this.props.onOptionsUpdated(this.state.options);
        }
      }
    );
  }

  appendOptions(options) {
    const allOptions = this.state.options.concat(options);
    return this.setOptions(allOptions);
  }

  getOptions({ search, page }) {
    if (this.props.selectFunc) {
      return this.props.selectFunc({ search, page });
    }
    return GeckoRequest.get(this.props.selectUrl, { search, page }).then(
      (response) => {
        if (response.data) {
          return response.data;
        }
        return response;
      }
    );
  }

  refreshOptions(search) {
    if (search === this.state.searchString) {
      return search;
    }
    this.setState({ searchString: search });
    if (this.state.searching) {
      return search;
    }
    this.setState({ loadingOptions: true, searching: true, page: 1 }, () => {
      setTimeout(() => {
        this.setState({ searching: false });
        this.getOptions({ search: this.state.searchString })
          .then((options) => {
            if (options.data) {
              options = options.data;
            }
            this.appendOptions(options.map(this.props.optionTransform));
          })
          .catch((err) => {
            console.error(err);
            this.setState({ loadingOptions: false });
          });
      }, 500);
    });
    return search;
  }

  fetchNextPage() {
    this.setState({ loadingOptions: true, page: this.state.page + 1 }, () => {
      this.getOptions({
        search: this.state.searchString,
        page: this.state.page,
      })
        .then((options) => {
          if (options.data) {
            options = options.data;
          }
          this.appendOptions(options.map(this.props.optionTransform));
        })
        .catch((err) => {
          console.error(err);
          this.setState({ loadingOptions: false });
        });
    });
  }

  handler(_key, value) {
    this.props.onChange(value);
  }

  render() {
    const config = {
      isLoading: this.state.loadingOptions,
      onInputChange: this.refreshOptions.bind(this),
      onMenuScrollToBottom: this.fetchNextPage.bind(this),
      ...this.props.field.config,
    };
    const field = {
      type: this.props.multi
        ? GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI
        : GECKO_CONSTS.FIELD_TYPE_SELECT,
      key: 'value',
      options: this.state.options,
      placeholder: this.props.placeholder,
      disabledWhen: () => this.props.disabled,
      ...this.props.field,
      config,
    };
    return (
      <div className="AsyncSelect">
        <GeckoField
          field={field}
          values={{ value: this.props.value }}
          handler={this.handler.bind(this)}
        />
      </div>
    );
  }
}

export default AsyncSelect;
